(function () {
  angular.module('app.referral-analytics.quickview', []);

})();